export default __webpack_public_path__ + "static/media/proj1_1.547545dc.jpg";